import { PureComponent } from 'react';

import { CSATChromePreview } from '../CSATChromePreview';
import { CSATWidgetMessage } from '../CSATWidgetMessage';

import styles from './index.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Thank You message */
  message: string;
};

export class CSATThankYouPreview extends PureComponent<PropsT> {
  render() {
    const { className, message } = this.props;

    return (
      <CSATChromePreview className={className}>
        <CSATWidgetMessage>
          <div className={styles.root} dir="auto">
            {message}
          </div>
        </CSATWidgetMessage>
      </CSATChromePreview>
    );
  }
}
